import {
    IWebsiteConstants,
    IDomainConstants,
    ISupportSite,
    IShareData,
    IShareSite,
} from './website-constants.interfaces';
import {
    FacebookConstants,
    LinkedInConstants,
    PinterestConstants,
    RedditConstants,
    TwitterConstants,
    KofiConstants,
    PatreonConstants,
    GoogleConstants,
    YoutubeConstants,
    DeveloperCompanyWebsiteConstants,
    ApplicationWebsiteConstants,
} from './website-constants-sites.classes';

export class WebsiteConstants implements IWebsiteConstants {
    //ShareSites
    public facebook: FacebookConstants = new FacebookConstants();
    public linkedIn: LinkedInConstants = new LinkedInConstants();
    public pinterest: PinterestConstants = new PinterestConstants();
    public reddit: RedditConstants = new RedditConstants();
    public twitter: TwitterConstants = new TwitterConstants();

    //SupportSites
    public kofi: KofiConstants = new KofiConstants();
    public patreon: PatreonConstants = new PatreonConstants();

    //Others
    public google: GoogleConstants = new GoogleConstants();
    public youtube: YoutubeConstants = new YoutubeConstants();

    //Main domain
    public developerCompanyWebsite: DeveloperCompanyWebsiteConstants = new DeveloperCompanyWebsiteConstants();
    public applicationWebsite: ApplicationWebsiteConstants = new ApplicationWebsiteConstants();

    private container: { [id: string]: IDomainConstants } = {
        //ShareSites
        [this.facebook.NAME]: this.facebook,
        [this.linkedIn.NAME]: this.linkedIn,
        [this.pinterest.NAME]: this.pinterest,
        [this.reddit.NAME]: this.reddit,
        [this.twitter.NAME]: this.twitter,

        //SupportSites
        [this.kofi.NAME]: this.kofi,
        [this.patreon.NAME]: this.patreon,

        //Others
        [this.google.NAME]: this.google,
        [this.youtube.NAME]: this.youtube,

        //Main domain
        [this.developerCompanyWebsite.NAME]: this.developerCompanyWebsite,
    };

    public getFullMainDomainUrl(type: string): string {
        return this.container[type].FULL_MAIN_DOMAIN_URL;
    }

    public getSupportUrl(type: string, userName: string): string {
        return (<ISupportSite>(<unknown>this.container[type])).getSupportUrl(userName);
    }

    public getShareUrl(type: string, data: IShareData): string {
        return (<IShareSite>(<unknown>this.container[type])).getShareUrl(data);
    }
}
